export default __webpack_public_path__ + "static/media/Group 4841.afe1d924.svg";